<template>
  <div class="custom-tooltip">
    <button @click="copyText(value)"
            @mouseout="hideTooltip"
            class="custom-tooltip-button">
      <span class="custom-tooltiptext" ref="tooltip">Хуулах</span>
      <i class="sr sr-file" id="copy-button"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text.toString())
      this.$refs.tooltip.innerHTML = 'Хуулсан'
    },
    hideTooltip() {
      this.$refs.tooltip.innerHTML = 'Хуулах'
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./CopyButton.scss";
</style>
